module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoMAAAABCAYAAACliaR0AAAA60lEQVRIie2VQQ3CQBBFXxWAAqoAFBQFrYKiABSAAlBAFVAFoAAUgAI49NwqgJBM0gTo7j/MkXfdyc++7OxM0jTNBLjTcwHmaByAMlI5BjohrbS8ECugErJGQBupOQGF6HkE8kiN6rkE9pGaBVALWYpnbXkKZyCL1CViluJZ2DvE+OzRX3h6dvaeCmtg6+Q5Ba6Rmsr+gcLVMod4AKmYtTXXEHObHx6eO2Aj3u1uPTKEt+cMuAlZmfVaCE/Pm91NYW9/NITqmduMDLExV4XWZtsQ3jsqtR7x8FR31Jtn5Py/i7/57+Iev10MxQs/7UP/h7haIwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/v2/order/boder.png
// module id = 3uC4
// module chunks = 1